export const Nl2br = {
  functional: true,
  props: {
    tag: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      required: false,
    },
  },
  render(createElement, context) {
    const _a = context.props
    const { tag } = _a
    const { className } = _a
    const text = context.props.text || ''
    return createElement(tag, {
      class: className,
    }, text.split('\n').reduce((accumulator, string) => {
      if (accumulator.length === 0) {
        return new Array(string)
      }
      return accumulator.concat([createElement('br'), string])
    }, []))
  },
}
